module.exports = "/_next/static/images/login-bg-a4658b72b4e4923c7b983a200ed4e6c1.png";